import { createStyles } from '@material-ui/styles';
import { ActionIcon, Text, withBaseProps } from '@topconagriculture/react-components';
import * as React from 'react';
import { useLayoutEffect, useRef } from 'react';
import { compose } from 'recompose';
import { getCorrectTime } from '../../utils';
const styles = (theme) => createStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.color.grey.lightest,
        backgroundImage: 'url(../../assests/Pattern.svg)',
    },
    textBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.space.padding.large,
        textAlign: 'center',
    },
    pageTitle: {
        margin: `${theme.space.padding.large}px 0`,
    },
    pageButton: {
        margin: `${theme.space.padding.largest}px 0`,
    },
    currentTime: {
        marginTop: 20,
    },
});
const ErrorHandler = (props) => {
    const { classes, theme, t } = props;
    const [currentTime, setCurrentTime] = React.useState(new Date(0));
    const [timer, setTimer] = React.useState(0);
    const mounted = useRef(true);
    useLayoutEffect(() => () => {
        mounted.current = false;
    }, []);
    React.useEffect(() => {
        if (mounted.current && timer === 0) {
            getCorrectTime((datetime) => {
                setCurrentTime(datetime);
                let time = new Date(datetime);
                const mTimer = window.setInterval(() => {
                    time = new Date(time.getTime() + 1000);
                    setCurrentTime(time);
                }, 1000);
                setTimer(mTimer);
            });
        }
        else {
            window.clearInterval(timer);
        }
    }, []);
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.textBox },
            React.createElement(ActionIcon, { iconName: "warning-2", iconSize: 100, iconColor: theme.color.grey.default }),
            React.createElement(Text, { block: true, bold: true, size: 50, transform: 'uppercase', color: theme.color.grey.default, className: classes.pageTitle }, t('common:auth:errors:authentication_failed')),
            React.createElement(Text, { block: true, size: 20, color: theme.color.grey.default, style: { padding: 10 } }, t('common:auth:errors:authentication_failed_desc')),
            React.createElement(Text, { block: true, size: 20, color: theme.color.grey.default }, t('common:auth:errors:authentication_failed_time_desc')),
            React.createElement(Text, { block: true, size: 35, color: theme.color.grey.default, style: { padding: 10 } }, currentTime.toLocaleTimeString()))));
};
export default compose(withBaseProps({ styles }))(ErrorHandler);
//# sourceMappingURL=ErrorHandler.js.map